"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withUISettingVisibility = exports.useIsPageVisible = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NotFound = require("../../components/not-found/NotFound");
var _SettingsContext = require("../../context/settings/SettingsContext");
var useIsPageVisible = function useIsPageVisible(pageId) {
  var _useSettings = (0, _SettingsContext.useSettings)(),
    settings = _useSettings.settings;
  var isPageVisible = (0, _react.useMemo)(function () {
    var _settings$angularUISe4, _settings$angularUISe5, _settings$angularUISe6;
    if (Array.isArray(pageId)) {
      return pageId.some(function (p) {
        var _settings$angularUISe, _settings$angularUISe2, _settings$angularUISe3;
        return settings === null || settings === void 0 ? void 0 : (_settings$angularUISe = settings.angularUISettings) === null || _settings$angularUISe === void 0 ? void 0 : (_settings$angularUISe2 = _settings$angularUISe.pages) === null || _settings$angularUISe2 === void 0 ? void 0 : (_settings$angularUISe3 = _settings$angularUISe2[p]) === null || _settings$angularUISe3 === void 0 ? void 0 : _settings$angularUISe3.shouldDisplayForCurrentUser;
      });
    }
    return settings === null || settings === void 0 ? void 0 : (_settings$angularUISe4 = settings.angularUISettings) === null || _settings$angularUISe4 === void 0 ? void 0 : (_settings$angularUISe5 = _settings$angularUISe4.pages) === null || _settings$angularUISe5 === void 0 ? void 0 : (_settings$angularUISe6 = _settings$angularUISe5[pageId]) === null || _settings$angularUISe6 === void 0 ? void 0 : _settings$angularUISe6.shouldDisplayForCurrentUser;
  }, [settings, pageId]);
  return isPageVisible;
};

/**
 * @param Component Page component you want to connect to UI settings
 * @param pageId Angular page UI settings - for now the navigation is connected to angular
 */
exports.useIsPageVisible = useIsPageVisible;
var withUISettingVisibility = function withUISettingVisibility(Component, pageId) {
  var WithUISettingsVisibility = function WithUISettingsVisibility(props) {
    var isPageVisible = useIsPageVisible(pageId);
    if (!isPageVisible) {
      return /*#__PURE__*/_react.default.createElement(_NotFound.NotFound, null);
    }
    return /*#__PURE__*/_react.default.createElement(Component, props);
  };
  return WithUISettingsVisibility;
};
exports.withUISettingVisibility = withUISettingVisibility;